import { request } from '../client';
import { endpoints } from '../endpoints';
import { asList } from './shape';

/**
 * Quota presets: reusable quota rows. `unit` is "completes" (numbers) or "percent" (of the target group's wanted
 * completes, converted when applied). `clientId` null = company-wide; otherwise only for that client.
 */

/** With a clientId: the company-wide presets plus that client's own. Without: every preset. */
export const listQuotaPresets = async (clientId, opts) =>
  asList(await request(endpoints.quotaPresets.all(), { query: clientId ? { clientId } : undefined, ...opts }));

/** Save the target group's SAVED quota rows as a preset (unit "completes"). 400 when the group has no quotas yet. */
export const createQuotaPresetFromTargetGroup = async (tgId, { name, description, clientId }) => {
  const preset = await request(endpoints.quotaPresets.fromTargetGroup(tgId), { method: 'POST', body: { name, description, clientId } });
  if (preset === null || preset === undefined) throw new Error('The preset was not saved: the server did not find the target group.');
  return preset;
};

export const deleteQuotaPreset = (id) => request(endpoints.quotaPresets.byId(id), { method: 'DELETE' });

/**
 * Copy a preset's rows into the target group's quotas (its quota record is updated in place). Percent presets are
 * converted with the basics' wanted completes into whole numbers that add up exactly (basics must be saved first).
 * The rows are then checked like a normal quota save: any problem is a 400 with `errors` and nothing is saved;
 * an unknown preset is a 404. Resolves the target group.
 */
export const applyQuotaPreset = async (projectId, tgId, presetId) => {
  const group = await request(endpoints.targetGroups.applyQuotaPreset(projectId, tgId, presetId), { method: 'POST' });
  if (group === null || group === undefined) throw new Error('The preset was not applied: the server did not find the campaign or target group.');
  return group;
};
